import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PollRes } from '../../../influencer/modules/poll/models/poll.inteface';
import { Router } from '@angular/router';
import { Paths } from '../../../../core/constants/path.constants';

interface PollOption {
  imageFile?: File;
  base64?: string;
  imageUrl?: string | null | File;
}

@Component({
  selector: 'vota-latest-poll',
  templateUrl: './latest-poll.component.html',
  styleUrl: './latest-poll.component.scss',
})
export class LatestPollComponent implements OnInit {
  @Input() latestPoll: PollRes | null = null;
  @Output() onCastVote = new EventEmitter<{
    pollId: number;
    pollOptionId: number;
  }>();

  constructor(private router: Router) {}

  ngOnInit(): void {
    console.log(this.latestPoll);
  }

  onNavigateToPoll(pollId: number): void {
    this.router.navigate([Paths.POLL, pollId]);
  }

  isImageAvailable(source: File | string | null | undefined): boolean {
    if (!source) return false;

    if (source instanceof File) {
      return source.type.startsWith('image/');
    }

    if (typeof source === 'string') {
      const trimmed = source.trim();
      return (
        trimmed.length > 0 &&
        (trimmed.startsWith('http') || trimmed.startsWith('data:image'))
      );
    }

    return false;
  }

  getImageSource(option: PollOption): string | null | undefined {
    if (option?.imageUrl instanceof File) {
      this.convertFileToBase64(option.imageUrl).then((base64) => {
        option.imageUrl = base64; // safe to assign base64 here
      });
    }

    if (
      typeof option.imageUrl === 'string' &&
      option.imageUrl.startsWith('data:image')
    ) {
      return option.imageUrl;
    }

    if (
      typeof option.imageUrl === 'string' &&
      option.imageUrl.trim().length > 0
    ) {
      return option.imageUrl;
    }

    return null;
  }

  onVote(pollOptionId: number): void {
    if (this.latestPoll?.id)
      this.onCastVote.emit({
        pollId: this.latestPoll.id!,
        pollOptionId: pollOptionId,
      });
  }

  convertFileToBase64(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = () => {
        const result = reader.result;
        if (typeof result === 'string') {
          resolve(result);
        } else {
          reject(new Error('Failed to convert file to base64.'));
        }
      };

      reader.onerror = (error) => reject(error);

      reader.readAsDataURL(file);
    });
  }
}
